import React from "react";
import { Star, BookOpen, Quote } from "lucide-react";

const Book = () => {
  return (
    <section
      id="book"
      data-testid="book-section"
      className="py-20 lg:py-28 bg-[#F0F9FF] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <span className="text-xs uppercase tracking-[0.22em] font-semibold text-[#D97706]">
              Featured Book
            </span>
            <p className="mt-4 font-heading text-xl sm:text-2xl text-slate-900 leading-tight">
              <em>From Diagnosis to Goodbye</em>
              <span className="block text-sm font-body text-slate-500 mt-1 not-italic">
                by Chaplain Derrick Hall
              </span>
            </p>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 leading-tight">
              Practical hope, written for the hardest seasons.
            </h2>
            <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
              <em>From Diagnosis to Goodbye</em> is a quiet, pastoral companion
              for anyone walking through grief, caregiving, burnout, or a
              season of emotional fog. Each chapter offers honest reflection,
              gentle insight, and small practices readers can carry into their
              week.
            </p>

            <div className="mt-6 flex items-center gap-3 text-sm text-slate-700">
              <div className="flex items-center gap-1 text-[#D97706]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="#D97706" stroke="#D97706" />
                ))}
              </div>
              <span className="text-slate-500">Loved by readers walking real seasons</span>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="https://www.amazon.com/Diagnosis-Goodbye-Restoring-Patients-Through/dp/0980212723"
                target="_blank"
                rel="noreferrer noopener"
                data-testid="book-amazon-link"
                className="inline-flex items-center gap-2 bg-[#D97706] hover:bg-[#B45309] text-white rounded-full px-6 py-3 text-sm font-medium transition-colors"
              >
                <BookOpen size={16} /> Buy on Amazon
              </a>
              <a
                href="#submit"
                data-testid="book-secondary-cta"
                className="inline-flex items-center gap-2 bg-white border border-slate-200 hover:border-[#0369A1] text-slate-800 rounded-full px-6 py-3 text-sm font-medium transition-colors"
              >
                Ask Chaplain Derrick a question
              </a>
            </div>

            <figure className="mt-10 rounded-2xl bg-white border border-slate-100 p-6 max-w-xl">
              <Quote className="text-[#0369A1]" size={20} />
              <blockquote className="mt-3 text-slate-700 leading-relaxed">
                &ldquo;It felt like sitting across from a chaplain who actually
                had time for me. Honest, warm, and surprisingly practical.&rdquo;
              </blockquote>
              <figcaption className="mt-3 text-xs uppercase tracking-widest text-slate-500">
                — A reader walking through grief
              </figcaption>
            </figure>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-white/60" aria-hidden />
            <img
              src="https://images.unsplash.com/photo-1775129667344-df7ac23d7739?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="An open book, journal and coffee on a quiet table"
              className="relative rounded-[1.75rem] w-full h-[520px] object-cover shadow-[0_30px_60px_-25px_rgba(15,23,42,0.25)]"
              data-testid="book-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Book;
